// components/LicenceSection.jsx
import React from "react";
import AllInclusiveIcon from "@mui/icons-material/AllInclusive";
import CheckCircleIcon  from "@mui/icons-material/CheckCircle";
import { Reveal }       from "../lib/hooks";
import { LICENCE_STEPS } from "../lib/data";
import LicenseFlowCard from "./LicenseFlowCard";

const COVERAGE = [
  "Perpetual license",
  "Valid after subscription ends",
  "Pay once, use forever",
];

const PILLS = ["Worldwide", "Perpetual", "All Media", "Instant PDF", "Post-Subscription"];

export default function LicenceSection() {
  return (
    <section className="bg-[#f4f6fb] dark:bg-[#161b22] relative overflow-hidden" style={{background : "rgb(var(--canvas))"}}>
      <div className="section-inner">
        <div className="grid lg:grid-cols-2 gap-6 sm:grid-cols-1">

          {/* Left — steps */}
          <Reveal direction="left">
            <div className="section-label">Licensing</div>
            <h2 className="section-title">License Manager<br />in your dashboard</h2>
            <p className="pricing-sub-header">
              SyncMama is built by industry professionals who know that creators need a legally valid document — not just a promise. Every sync license is E&O-ready. One click on your dashboard, and a worldwide sync license for your project is issued in your name.
            </p>
            
          </Reveal>

          {/* Right — infinity card */}
          <Reveal direction="right" className="pb-10">
            
            <LicenseFlowCard />
          </Reveal>

        </div>
      </div>
    </section>
  );
}
